module.exports = __webpack_public_path__ + "img/symbol_6.6b603f08.png";